import { Tag } from '@chakra-ui/react';

export const GradientTag = ({ children, ...props }) => {
  return (
    <Tag
      bg="radial-gradient(42.61% 55.51% at 60.46% 100%, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 100%) , radial-gradient(58.56% 126.24% at 31.37% 0%, rgba(255, 255, 255, 0.46) 0%, rgba(255, 255, 255, 0) 77.6%) , radial-gradient(74.14% 74.14% at 102.47% 39.73%, #9E00FF 0%, rgba(158, 0, 255, 0.34) 77.6%) , radial-gradient(88.4% 88.4% at 86.12% 6.46%, #FF1C89 0%, rgba(229, 102, 163, 0) 56.56%) , radial-gradient(124.52% 124.52% at -3.99% 35.36%, #0066FF 0%, rgba(0, 78, 255, 0) 69.33%) , #FF00C7"
      color="#fff"
      borderRadius="full"
      {...props}
    >
      {children}
    </Tag>
  );
};
